exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button.drag-over{outline:none;border-color:#7061ff;box-shadow:0 0 0 .2rem rgba(112,97,255,.25)}", ""]);

// exports
